// Utility function to generate URL-safe slugs from article metadata
export const generateSlug = (title, author, date) => {
  const sanitize = (str) => {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric chars with hyphens
      .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
  };

  const titleSlug = sanitize(title);
  const authorSlug = sanitize(author);
  
  return `${titleSlug}-${authorSlug}-${date}`;
};

// Function to parse slug back to components (for matching)
export const parseSlug = (slug) => {
  // Since we know the format is title-author-YYYY-mm-dd
  // We'll extract the date (last 10 characters) and work backwards
  const dateMatch = slug.match(/-(\d{4}-\d{2}-\d{2})$/);
  if (!dateMatch) return null;
  
  const date = dateMatch[1];
  const beforeDate = slug.slice(0, -(date.length + 1)); // Remove date and hyphen
  
  // Split by hyphens and find where author likely starts
  // This is a simplified approach - in production you might want more robust parsing
  const parts = beforeDate.split('-');
  
  return {
    date,
    slug: beforeDate,
    originalSlug: slug
  };
};